import { render, staticRenderFns } from "./DefinitionResource.vue?vue&type=template&id=f119fe98&"
import script from "./DefinitionResource.vue?vue&type=script&lang=js&"
export * from "./DefinitionResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports